import React from "react";
import { Marker, InfoWindow } from "@react-google-maps/api";
import { InfoContainer, InfoHeader } from "./styles";

const SimpleMapMarker = (props) => {
  const { item, isOpen, idMarker, icon, config, clock = "", lat, lng } = props;
  const { onSelect, onCloseInfo } = props;

  const validLat = typeof lat === 'number' ? lat : parseFloat(lat);
  const validLng = typeof lng === 'number' ? lng : parseFloat(lng);

  if (isNaN(validLat) || isNaN(validLng)) {
    return null;
  }

  return (
    <Marker
      onClick={() => onSelect(item[idMarker])}
      position={{ lat: validLat, lng: validLng }}
      icon={{
        url: icon,
      }}
    >
      {isOpen && (
        <InfoWindow
          position={{ lat: validLat, lng: validLng }}
          clickable={true}
          onCloseClick={() => onCloseInfo(item[idMarker])}
        >
          <InfoContainer>
            <InfoHeader>
              {config.title}
              {config.field ? item[config.field] : ""}
              {` ${clock}`}
            </InfoHeader>
          </InfoContainer>
        </InfoWindow>
      )}
    </Marker>
  );
};

export default React.memo(SimpleMapMarker);
